import { useCallback, useRef } from 'react';
import { useIntersectionObserver } from '@crehana/react-hooks';
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import cn from 'clsx';
import { RIVE_ACHIEVEMENT_LOGO_URL } from "../../../shared/constants";
import { LOGO_COMMON_SIZE_CLASSNAMES } from "./constants";
import { getArtboardNameBySubjectName } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var AchievementLogoRiveAnimation = function AchievementLogoRiveAnimation(_ref) {
  var logoName = _ref.logoName,
    subjectName = _ref.subjectName,
    className = _ref.className,
    style = _ref.style;
  var containerRef = useRef(null);
  var observer = useIntersectionObserver(containerRef, {
    threshold: 0.4,
    freezeOnceVisible: true
  });
  var isIntersecting = !!(observer !== null && observer !== void 0 && observer.isIntersecting);
  var artboard = getArtboardNameBySubjectName(subjectName);
  var _useRive = useRive({
      src: RIVE_ACHIEVEMENT_LOGO_URL,
      autoplay: true,
      layout: new Layout({
        fit: Fit.Contain,
        alignment: Alignment.Center
      }),
      artboard: artboard,
      useOffscreenRenderer: true
    }),
    rive = _useRive.rive,
    RiveComponent = _useRive.RiveComponent;
  var playHandler = useCallback(function () {
    if (rive) {
      rive.reset({
        artboard: artboard
      });
      rive.play();
    }
  }, [artboard, rive]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    style: style,
    className: cn('tw-mx-auto', LOGO_COMMON_SIZE_CLASSNAMES, className),
    role: "presentation",
    "aria-label": logoName,
    children: isIntersecting && /*#__PURE__*/_jsx(RiveComponent, {
      className: LOGO_COMMON_SIZE_CLASSNAMES,
      onMouseEnter: playHandler
    })
  });
};
export default AchievementLogoRiveAnimation;